import type { HTMLAttributes } from 'react';

import type { AplusLayoutDefaultProps } from '../../Layouts/types';
import type { APlusItem } from '../../types';

import { Check } from '../Check/Check';
import { Icon } from '../Icon/Icon';
import { Name } from '../Name/Name';
import { Price } from '../Price/Price.client';
import { Info } from '../Info/Info.client';

type CenterInFirstLineProps = Pick<HTMLAttributes<HTMLDivElement>, 'className'> & {
  children: React.ReactNode;
};

const CenterInFirstLine = ({ children, className }: CenterInFirstLineProps) => (
  <div className={`flex h-4 items-center${className ? ` ${className}` : ''}`}>{children}</div>
);

type ItemProps = Omit<APlusItem, 'serviceLayerId' | 'orderId' | 'clusterLabel' | 'preselected'> & {
  id: string;
  selected: boolean;
  onInfoClickHandler: () => void;
  onItemChangeHandler: (uuid: string) => void;
} & Pick<AplusLayoutDefaultProps, 'currency'>;

/**
 * atom for Aplus - renders an APlus item row
 */
export const Item = ({
  uuid,
  mandatory,
  serviceIcon,
  name,
  price,
  free,
  currency,
  id,
  selected,
  onInfoClickHandler,
  onItemChangeHandler,
}: ItemProps) => {
  const handleChange = () => {
    onItemChangeHandler(uuid);
  };

  return (
    <div className="text-size-body-sm col-span-5 grid grid-cols-subgrid gap-x-1.5">
      <CenterInFirstLine>
        <Check mandatory={mandatory} id={id} selected={selected} onChange={handleChange} />
      </CenterInFirstLine>
      <div>
        <Icon src={serviceIcon} />
      </div>
      <div className="flex justify-stretch">
        <div className="flex items-center">
          <Name mandatory={mandatory} name={name || ''} id={id} />
        </div>
      </div>
      <CenterInFirstLine className="justify-end">
        <Price price={price} currency={currency} free={free} mandatory={mandatory} />
      </CenterInFirstLine>
      <CenterInFirstLine>
        <Info type="icon" onClick={onInfoClickHandler} trackingData={{ uuid, name }} />
      </CenterInFirstLine>
    </div>
  );
};
